import React from 'react'
import { observer } from 'mobx-react'
import InfiniteScrollLoader from 'components/InfiniteScrollLoader'
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
} from 'components/Table/ClickableTable'
import JobsListEmpty from 'jobs/components/JobsListEmpty'
import { Id } from 'types/definitions'
import FirmDashboardJobsTableRow from './FirmDashboardJobsTableRow'
import FirmDashboardJobsViewModel from '../FirmDashboardJobsViewer/FirmDashboardJobTableViewModel'
import styles from './FirmDashboardJobsTable.sass'

/**
 * Maps column names to their respective styles.
 */
const jobTableColumnStyles: Record<string, any> = {
  'Job title': styles.primaryColumn,
  'Job ID': styles.shortIdColumn,
  Status: styles.statusColumn,
  'Client team': styles.teamColumn,
  'Job progress': styles.progressionColumn,
  Submitted: styles.dateColumn,
}

interface FirmDashboardJobsTableProps {
  vm: FirmDashboardJobsViewModel
}

export default observer(function FirmDashboardJobsTable({
  vm,
}: FirmDashboardJobsTableProps) {
  const columns = vm.columnManager.filteredColumns

  return (
    <div>
      {!vm.showEmptyView ? (
        <>
          <Table striped stickyHeader className={styles.jobsTable}>
            <TableHead className={styles.tableHead}>
              {columns
                .filter((col) => col.visible)
                .map((col) => (
                  <TableHeader
                    key={col.id}
                    canSort={col.sortable}
                    sortOrder={vm.getSortOrder(col)}
                    onSort={(newSort) => {
                      vm.setSortOrder(col, newSort)
                    }}
                    className={jobTableColumnStyles[col.header]}
                  >
                    {col.header}
                  </TableHeader>
                ))}
            </TableHead>
            <TableBody>
              {vm.filteredJobs.map((job) => (
                <FirmDashboardJobsTableRow
                  vm={vm}
                  job={job}
                  key={Id.assert(job.id)}
                />
              ))}
            </TableBody>
          </Table>
          <InfiniteScrollLoader scrollProvider={vm.searcher.scroller} />
        </>
      ) : (
        <div className={styles.emptyView}>
          <JobsListEmpty
            onClearSearchFilterClick={() => {
              vm.searcher.clearFilters()
            }}
          />
        </div>
      )}
    </div>
  )
})
